import React, { useEffect, useState } from 'react'
import Header from '../Header';
import SideBar from '../SideBar';
import './SelectedApartmentReport.scss'
import { Link, useParams } from 'react-router-dom';
import { Card, Form, Button, Row, Col, Modal } from 'react-bootstrap';
import OccupancyReport from './OccupancyReport';
import RentPaymentReport from './RentPaymentReport';
import IncomeReport from './IncomeReport';
import OwnersReport from './OwnersReport';
import UtilitiesReport from './UtilitiesReport';
import ApartmentImage from '../../../assets/img/apartment1.jpg'
import ReactApexChart from 'react-apexcharts';

// auth imports
import jwt_decode from "jwt-decode";
import { serverUrl } from "../../../serverUrl";
import FailedReconciliation from './FailedReconciliation';
import OverflowReport from './OverflowReport';

function SelectedApartmentReport() {

  // getting the id and finding the apparment details
  const { id } = useParams();
  // sidebar and header functions
  const [showSidebar, setShowSidebar] = useState(true);

  function toggleSidebar() {
    setShowSidebar(!showSidebar);
  }

  // get the current month so that i can filter out the total income
  const months = Array.from({ length: 12 }, (_, i) => {
    const month = new Date(new Date().getFullYear(), i, 1);
    return month.toLocaleString('default', { month: 'long' });
  });

  // Get the current month automatically
  const currentMonthIndex = new Date().getMonth();
  const currentMonth = months[currentMonthIndex];
  const currentYear = new Date().getFullYear();

  // selected Apartment
  const [apartmentSelected, setApartmentSelected] = useState([])


  // get the user who is logged in and the date related to them
  const accessToken = localStorage.getItem("authTokens");
  // get the access token
  const parsedTokens = JSON.parse(accessToken);
  const access = parsedTokens.access;


  // headers access token
  const config = {
    headers: { Authorization: `Bearer ${access}` }
  }
  // decoding the token so that i can get the user id
  const decodedToken = jwt_decode(accessToken);
  const userId = decodedToken.user_id;

  // get cuurent month and year
  const [totalHouse, setTotalHouses] = useState('')
  const [occupancyPercentage, setOccupancyPercentage] = useState('')
  const [activeOccupancy, setActiveOccupancy] = useState('')
  useEffect(() => {
    // get the landlord details that are linked to the user
    serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config)
      .then((res) => {
        // get the landlord Id
        const landlordIds = res.data.results.map((landlord) => landlord.id);

        // using the landlord id get the apartments linked to the landlord
        landlordIds.map((landlordId) => {
          return serverUrl.get(`/landlord/landlord-apartment_name/?landlord_id=${landlordId}`, config)
            .then((res) => {
              const selectedApartmentObj = res.data.results.find(utilitiesApartment => utilitiesApartment.id === parseInt(id));
              setApartmentSelected(selectedApartmentObj)
            })
            .catch((error) => {
              console.log(error);
            });

        });
      })
      .catch((error) => {
        console.log(error);
      });

    // get the report data for the apartment
    serverUrl.get(`/landlord/react-apartmentfull-report?apartment_id=${id}&month=${currentMonth}&year=${currentYear}`, config)
      .then((res) => {
        setTotalHouses(res.data.results[0].total_houses)
        setOccupancyPercentage(res.data.results[0].current_occupancy_percentage)
        setActiveOccupancy(res.data.results[0].active_occupancy)

      })
  }, [])


  // randomise for each apartment

  // charts for the reports
  // chart occupancy
  const [chartOptions, setChartOptions] = useState({
    chart: {
      id: 'occupancy-chart',
      type: 'line',
      stacked: true,
      zoom: {
        enabled: false
      },
      animations: {
        enabled: true
      }
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true
    },
    grid: {
      show: false,
    },
    stroke: {
      curve: 'smooth',
      width: "2",
      colors: ['#3498db'],
    },
  });

  const [chartSeries, setChartSeries] = useState([
    {
      name: 'Occupancy',
      data: [],
    },
  ]);

  useEffect(() => {
    // Fetch data for each month
    const fetchData = async () => {
      const newChartSeries = {
        name: 'Occupancy',
        data: [],
      };
      for (let i = 0; i < months.length; i++) {
        // Fetch data for each month using the month label
        const month = months[i];
        const response = await serverUrl.get(`/landlord/react-apartmentfull-report?apartment_id=${id}&month=${month}&year=${currentYear}`, config);

        // Assuming response.data.home is the occupancy data for the month
        newChartSeries.data.push(response.data.results[0].current_occupancy_percentage);
      }

      setChartSeries([newChartSeries]);
    };

    fetchData();
  }, []);

  // chart incomeReport
  const [chartOptionsIncome, setChartOptionsIncome] = useState({
    chart: {
      id: 'occupancy-chart',
      zoom: {
        enabled: false
      },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true, // Enable tooltip
      style: {
        fontSize: '12px',
      },
      fixed: {
        enabled: false, // Set fixed property to false
      },

    },
    stroke: {
      curve: 'smooth',
      width: "2",
      colors: ['#8e44ad'],
    },

  });

  const [chartSeriesIncome, setChartSeriesIncome] = useState([
    {
      name: 'Income Report',
      data: [65, 59, 80, 81, 56, 55, 40, 20, 10, 45, 75, 90],

    },
  ]);

  // chart payment report
  const [chartOptionsPayment, setChartOptionsPayment] = useState({
    chart: {
      id: 'occupancy-chart',
      zoom: {
        enabled: false
      },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true,
      style: {
        fontSize: '12px',
      },
      fixed: {
        enabled: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: "2",
      // colors: ['#8e44ad', '#e74c3c', '#3498db'],
    },
  });

  const [chartSeriesPayment, setChartSeriesPayment] = useState([
    {
      name: 'Fully Paid',
      data: [65, 59, 80, 81, 56, 55, 40, 20, 10, 45, 75, 90],
    },
    {
      name: 'Partially Paid',
      data: [35, 45, 60, 75, 45, 50, 30, 15, 5, 35, 65, 80],
    },
    {
      name: 'Not Paid',
      data: [80, 75, 60, 45, 70, 65, 80, 90, 95, 70, 50, 30],
    },
  ]);

  // chart UtilitiesReport
  const [chartOptionsUtilities, setChartOptionsUtilities] = useState({
    chart: {
      id: 'occupancy-chart',
      zoom: {
        enabled: false
      },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true, // Enable tooltip
      style: {
        fontSize: '12px',
      },
      fixed: {
        enabled: false, // Set fixed property to false
      },

    },
    stroke: {
      curve: 'smooth',
      width: "2",
      colors: ['#f39c12'],
    },

  });

  const [chartSeriesUtilities, setChartSeriesUtilities] = useState([
    {
      name: 'Utilities Report',
      data: [65, 59, 80, 81, 56, 55, 40, 20, 10, 45, 75, 90],

    },
  ]);

  // chart failled reconciliations
  const [chartOptionsFailed, setChartOptionsFailed] = useState({
    chart: {
      id: 'occupancy-chart',
      zoom: {
        enabled: false
      },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true, // Enable tooltip
      style: {
        fontSize: '12px',
      },
      fixed: {
        enabled: false, // Set fixed property to false
      },

    },
    stroke: {
      curve: 'smooth',
      width: "2",
      colors: ['#1abc9c'],
    },

  });

  const [chartSeriesFailed, setChartSeriesFailed] = useState([
    {
      name: 'Failed Transactions',
      data: [65, 59, 80, 81, 56, 55, 40, 20, 10, 45, 75, 90],

    },
  ]);

  // chart overpayment
  const [chartOptionsOverpayment, setChartOptionsOverpayment] = useState({
    chart: {
      id: 'occupancy-chart',
      zoom: {
        enabled: false
      },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true, // Enable tooltip
      style: {
        fontSize: '12px',
      },
      fixed: {
        enabled: false, // Set fixed property to false
      },

    },
    stroke: {
      curve: 'smooth',
      width: "2",
      colors: ['#2ecc71'],
    },

  });

  const [chartSeriesOverpayment, setChartSeriesOverpayment] = useState([
    {
      name: 'Failed Transactions',
      data: [65, 59, 80, 81, 56, 55, 40, 20, 10, 45, 75, 90],

    },
  ]);

  // administars
  const [chartOptionsAdmin, setChartOptionsAdmin] = useState({
    chart: {
      id: 'occupancy-chart',
      zoom: {
        enabled: false
      },
    },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
        'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ],
    },
    tooltip: {
      enabled: true, // Enable tooltip
      style: {
        fontSize: '12px',
      },
      fixed: {
        enabled: false, // Set fixed property to false
      },

    },
    stroke: {
      curve: 'smooth',
      width: "2",
      colors: ['#ff6600'],
    },

  });

  const [chartSeriesAdmin, setChartSeriesAdmin] = useState([
    {
      name: 'Administators',
      data: [65, 59, 80, 81, 56, 55, 40, 20, 10, 45, 75, 90],

    },
  ]);

  const chartOptionsIssues = {
    chart: {
      id: 'issues-chart',
      toolbar: {
        show: false,
      },
    },
    labels: ['Complaints', 'Issues', 'Suggestions'],
    // Specify colors for each slice of the pie chart
    colors: ['#FF5733', '#FFCB33', '#33FF33'],
    plotOptions: {
      pie: {
        donut: {
          size: '70%',
        },
      },
    },
  };

  const chartSeriesIssues = [65, 59, 80];

  // get the occupancy requirements
  // const [occupancyRecords, setOccupancyRecords] = useState([])
  // const [occupiedHouses, setOccupiedHouses] = useState('')
  // const [totalHouses, setTotalHouses] = useState('')

  // useEffect(() => {
  //   serverUrl.get(`/landlord/react-occupancy-report/?apartment_id=27&month=august&year=2023`, config)
  //     .then((res) => {
  //       setOccupiedHouses(res.data.occupied_houses)
  //       setTotalHouses(res.data.total_houses)
  //     })
  //     .catch((error) => {
  //       console.log(error)
  //     })
  // })

  return (
    <>
     
      <div className='report_Apartment'>
        {/* top display of the report */}
        <div className='image_Apartment_report'>
          <img src={ApartmentImage} alt={apartmentSelected.name} />
          <p>{apartmentSelected.name} Report</p>
          <span>{apartmentSelected.location}</span>
        </div>

        {/* filtering based on the month or year  */}
        <div className='filterCardSectionReports'>
          <p>Reports for the month of {currentMonth}</p>


        </div>
        {/* the cards to be displayed for the reports */}
        <Row style={{ marginTop: "10rem" }}>

          <Col md={4}>
            <div>
              <Card className='ReportCards occupancyCard'>
                <Card.Body>
                  <h3 className='mb-4'>Occupancy Reports</h3>
                  {/* to do later on */}
                  {/* <div className='d-flex justify-content-between'>
                    <p>{activeOccupancy}/{totalHouse}</p>
                    <p>{occupancyPercentage}% occupied<span className='ms-1' style={{ fontSize: '0.8rem', color: '#2ecc71' }}> +8%</span></p>
                  </div>
                  <ReactApexChart options={chartOptions} series={chartSeries} type="line" height={250} /> */}

                  <Link to={`/occupancy-report/${id}`} className='text-decoration-none text-white'>
                    <Button >

                      View detailed report
                    </Button>

                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Card className='ReportCards incomeCard'>
                <Card.Body>
                  <h3 className='mb-4'>Rent Income Report</h3>
                  {/* to do later one */}

                  {/* <div className='d-flex justify-content-between'>
                    <p>Ksh.97,900 /Ksh.1,004,201</p>
                    <p>50% paid</p>
                  </div>
                  <ReactApexChart options={chartOptionsIncome} series={chartSeriesIncome} type="line" height={250} /> */}


                  <Link to={`/income-report/${id}`} className='text-decoration-none text-white'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Card className='ReportCards paymentCard'>
                <Card.Body>
                  <h3 className='mb-4'>Payment Reports</h3>
                  {/* to do later one */}

                  {/* <div className='paymentDetailsReport'>
                    <p>Fully paid:20</p>
                    <p>Partially paid:10</p>
                    <p>Unpaid:65</p>
                  </div>
                  <ReactApexChart options={chartOptionsPayment} series={chartSeriesPayment} type="line" height={250} /> */}

                  <Link to={`/payment-report/${id}`} className='text-decoration-none text-white'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>



        </Row>


        <Row style={{ marginTop: "1rem" }}>
          <Col md={4}>
            <div>
              <Card className='ReportCards utilitiesCard'>
                <Card.Body>
                  <h3 className='mb-4'>Utilities Income</h3>
                  {/* to do later one */}

                  {/* <div className='d-flex justify-content-between'>
                    <p>Ksh.97,900 /Ksh.1,004,201</p>
                    <p>50% paid</p>
                  </div>
                  <ReactApexChart options={chartOptionsUtilities} series={chartSeriesUtilities} type="line" height={250} /> */}
                  <Link to={`/utility-report/${id}`} className='text-decoration-none text-white'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Card className='ReportCards failedCard'>
                <Card.Body>
                  <h3 className='mb-4'>Failed Reconciliation</h3>
                  {/* to do later one */}

                  {/* <div className='d-flex justify-content-between'>
                    <p>30 transactions failed</p>
                    <p>Value : Ksh 70,000</p>
                  </div>
                  <ReactApexChart options={chartOptionsFailed} series={chartSeriesFailed} type="line" height={250} /> */}

                  <Link to={`/failed-report/${id}`} className='text-decoration-none text-white'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Card className='ReportCards overpaymentCard'>
                <Card.Body>
                  <h3 className='mb-4'>Overpayment Report</h3>
                  {/* to do later one */}

                  {/* <div className='d-flex justify-content-between'>
                    <p>30 transactions</p>
                    <p>Value : Ksh 70,000</p>
                  </div>
                  <ReactApexChart options={chartOptionsOverpayment} series={chartSeriesOverpayment} type="line" height={250} /> */}

                  <Link to={`/overpayment-report/${id}`} className='text-decoration-none text-white'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

        </Row>

        <Row>

          <Col md={4}>
            <div>
              <Card className='ReportCards systemCard'>
                <Card.Body>
                  <h3 className='mb-4'>System Administrators</h3>
                  {/* to do later one */}

                  {/* <p>3 Administrators</p>
                  <ReactApexChart options={chartOptionsAdmin} series={chartSeriesAdmin} type="line" height={250} /> */}
                  <Link to={`/owner-report/${id}`} className='text-decoration-none text-white'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Card className='ReportCards issuesCard'>
                <Card.Body>
                  <h3 className='mb-4'>Tenants Feedback</h3>
                  {/* to do later one */}

                  {/* <p>1,213 reported</p>
                  <ReactApexChart options={chartOptionsIssues} series={chartSeriesIssues} type="pie" height={250} /> */}

                  <Link to={`/tenants-feedback/${id}`} className='text-decoration-none text-white mt-5'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col md={4}>
            <div>
              <Card className='ReportCards paymentsUpdatesCard'>
                <Card.Body>
                  <h3 className='mb-4'>Unpaid Invoices</h3>
                  {/* to do later one */}

                  {/* <p>1,213 reported</p>
                  <ReactApexChart options={chartOptionsIssues} series={chartSeriesIssues} type="pie" height={250} /> */}

                  <Link to={`/payments-updates/${id}`} className='text-decoration-none text-white mt-5'>
                    <Button >
                      View detailed report
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>


      </div>
    </>
  )
}

export default SelectedApartmentReport